export default function makeTotalDimensions(draft) {
  const { width, height, border } = draft;
  return `${width + border * 2}" x ${height + border * 2}"`;
}
